import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import Icons from './Icons';
import styles from './styles/index.module.scss';

const Icon = ({
  size,
  fill,
  id,
  children,
  onClick,
  onKeyPress,
  isB2B,
  ...restProps
}) => {
  const capitalizedName = id.charAt(0).toUpperCase() + id.slice(1);
  const { b2c: B2CIconComponent, b2b: B2BIconComponent } = Icons[
    capitalizedName
  ];

  const IconComponent = isB2B ? B2BIconComponent : B2CIconComponent;
  const wrap = child => {
    if (isB2B && B2BIconComponent) {
      return child;
    }
    return (
      <svg
        className={styles.svg}
        width={`${String(size)}px`}
        height={`${String(size)}px`}
        viewBox="0 0 32 32"
        role="img"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
      >
        {child}
      </svg>
    );
  };
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      {...restProps}
      className={cn(styles.icon, restProps.className)}
      onClick={onClick}
      onKeyPress={onKeyPress}
      role={onClick ? 'button' : 'img'}
    >
      {wrap(<IconComponent size={size} />)}
      {children ? <div className={styles.children}>{children}</div> : null}
    </div>
  );
};

Icon.displayName = 'Icon';

Icon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fill: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  id: PropTypes.string.isRequired,
  isB2B: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
};

Icon.defaultProps = {
  size: 32,
  fill: '#fff',
  isB2B: false,
  children: undefined,
  onClick: undefined,
  onKeyPress: () => {},
};

export default Icon;
